module.exports = __webpack_public_path__ + "static/media/gallery_07.bc96dd17.jpg";